import { TipoEstructura } from "../../interfaces/iDataStateJobs";
import { iProyectoABP, iProyectoUA } from "../../interfaces/Proyecto/iProyecto";


// enums.js
export const Etapas = {
  ETAPA_0: 0,
  ETAPA_1: 1,
};

export const TiposEstructura = {
  APRENDIZAJE_BASADO_EN_PROYECTOS: "aprendizaje_basado_en_proyectos",
  UNIDAD_ACTIVA: "unidad_activa",
};

export const NumeroEtapaFinal: Record<TipoEstructura, number> = {
  unidad_activa: 1,
  aprendizaje_basado_en_proyectos: 2,
};

export const dataProyect: Record<TipoEstructura, iProyectoUA | iProyectoABP> = {
  unidad_activa: {
    nombre: "",
    tipo_estructura: "Unidad Activa",
    adaptaciones_curriculares: "",
    nivel_curso: "",
    materias: [],
    objetivos_aprendizaje: [],
    texto_libre: "",
    condiciones_contexto: "",
    caracterizacion: "",
    seleccion_modelo: "",
    configuracion: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    cantidad_de_semanas: 8,
    No_sesiones: 1,
    ods: [],
    conceptos_clave: [],
    user_choice_stage_0: "",
    user_choice_stage_1: "",
    objetivo_docente: [],
    usuario: {},
    ummiappId: "",
    ummiappName: "",
    version: "cerrada",
    idioma:"español"
  },
  aprendizaje_basado_en_proyectos: {
    tema: "",
    tipo_estructura: "Aprendizaje basado en proyectos",
    nivel_curso: "",
    materias: [],
    objetivos_aprendizaje: [],
    caracteristicas_estudiantes: "",
    habilidad_socioemocional: "",
    competencias_siglo: "",
    adaptaciones_curriculares: "",
    condiciones_contexto: "",
    caracterizacion: "",
    seleccion_modelo: "",
    configuracion: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    cantidad_de_semanas: 8,
    horas_semanales: 12,
    No_sesiones: 1,
    ods: [],
    conceptos_clave: [],
    user_choice_stage_0: "",
    user_choice_stage_1: "",
    problematicas: [],
    usuario: {},
    ummiappId: "",
    ummiappName: "",
    version: "cerrada",
    idioma:"español"
  },
};
